<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      show-save-button
      unit="学校信息"
      id-key="SchoolId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="学校名称" prop="SchoolName">
              <el-input size="mini" v-model="data.SchoolName" placeholder="请填写学校名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="启用状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="序号" prop="Sn">
              <el-input-number :min="0" v-model="data.Sn"></el-input-number>
              <span class="t-tips" v-if="!isMB">*值越小排得越前</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="小程序" prop="EnableMini">
              <el-radio-group v-model="data.EnableMini">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="推送公众号" prop="PushAccount">
              <el-select v-model="data.PushAccount" placeholder="请选择">
                <el-option label="霈昇科技" :value="0"></el-option>
                <el-option label="智慧金中" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="扣费规则" prop="ChargeRemark">
              <el-input type="textarea" placeholder="请输入" v-model="data.ChargeRemark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="24" v-if="!isMB">
          <el-form-item label="展示图片">
            <single-upload
              :data="uploadData"
              @delLogo="delPic"
              @input="onsuccess"
              uploadUrl="/api/Common/UploadPicture"
              v-model="PictureUrl"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="!isMB">
          <el-form-item label="二维码">
            <single-upload
              :data="uploadDataQr"
              @delLogo="delPicQr"
              @input="onsuccessQr"
              uploadUrl="/api/Common/UploadPicture"
              v-model="QrCodeUrl"
            />
          </el-form-item>
        </el-col>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singleUpload from "@/components/common/photo/singleUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singleUpload,
  },
  data() {
    return {
      data: {
        SchoolId: 0,
        SchoolName: "",
        Sn: 0,
        Status: 1,
        BannerUrl: "",
        QrCodeUrl: "",
        EnableMini: 0,
        PushAccount: 0, //霈昇科技/智慧金中
        ChargeRemark: "", //扣费规则
      },
      PictureUrl: "",
      QrCodeUrl: "",
      uploadData: {
        dic: "BannerUrl",
      },
      uploadDataQr: {
        dic: "QrCodeUrl",
      },
      api: require("@/api/st/school").default,
      isMB: this.$store.state.isMB,
      rules: {
        SchoolName: [{ required: true, message: "请填写学校名称" }],
        Sn: [{ required: true, message: "请填写序号" }],
        // UpperLimit: [
        //   { required: true, message: "请填写正整数" },
        //   { validator: this.$commonJs.validateRules.int },
        // ],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {},
    onEditOpened(row) {
      this.PictureUrl = row.BannerUrl;
      this.QrCodeUrl = row.QrCodeUrl;
    },
    onsuccess(e) {
      this.PictureUrl = e;
      this.data.BannerUrl = e;
    },
    delPic() {
      this.data.BannerUrl = "";
      this.PictureUrl = "";
    },
    onClosed() {
      this.PictureUrl = "";
      this.QrCodeUrl = "";
    },
    onsuccessQr(e) {
      this.QrCodeUrl = e;
      this.data.QrCodeUrl = e;
    },
    delPicQr() {
      this.data.QrCodeUrl = "";
      this.QrCodeUrl = "";
    },
  },
};
</script>
<style lang="scss">
</style>